import React from 'react';
import { array, func, string } from 'prop-types';
import { intlShape } from 'react-intl';
import classNames from 'classnames';
import { filter, map } from 'ramda';

import ExtraItem from './ExtraItem/ExtraItem';
import css from './ExtraPanel.module.css';
import { isNilOrEmpty } from '../../../../util/validators';

const ExtraPanel = (props) => {
  const {
    className,
    selectedExtrasByListings,
    setSelectedExtrasByListings,
    handleSubmit,
    listingId,
    intl,
    paidExtrasData,
    light
  } = props;
  const selectedExtras = selectedExtrasByListings[listingId] ?? [];
  const handleClickOnExtra = (extraId) => {
    if (isNilOrEmpty(selectedExtras)) {
      setSelectedExtrasByListings(prev => ({ ...prev, [listingId]: [extraId] }));
      return;
    }
    if (selectedExtras.includes(extraId)) {
      setSelectedExtrasByListings(prev => ({
        ...prev,
        [listingId]: filter(id => id !== extraId, prev[listingId]),
      }));
      return;
    }

    setSelectedExtrasByListings(prev => ({ ...prev, [listingId]: [...prev[listingId], extraId] }));
  };
  const headingText = intl.formatMessage({ id: 'CheckoutExtraPage.ExtraPanel.heading' });
  const panelInfoText = intl.formatMessage({ id: 'CheckoutExtraPage.ExtraPanel.panelInfo' });
  const submitText = intl.formatMessage({ id: 'Marketplace.continue' });
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      {!light && (
        <>
          <h1 className={css.heading}>{headingText}</h1>
          <span className={css.panelInfo}>{panelInfoText}</span>
        </>
      )}
      <div className={css.extraList}>
        {map((extraData) => {
          return (
            <ExtraItem
              key={extraData.id}
              className={css.extraItem}
              extraData={extraData}
              intl={intl}
              isSelected={selectedExtras.includes(extraData.id)}
              onClick={() => handleClickOnExtra(extraData.id)}
            />
          );
        }, paidExtrasData)}
      </div>
    </div>
  );
};

ExtraPanel.defaultProps = {
  className: null,
};

ExtraPanel.propTypes = {
  className: string,
  exposeSelectedExtras: func.isRequired,
  handleSubmit: func.isRequired,
  intl: intlShape.isRequired,
  paidExtrasData: array.isRequired,
};

export default ExtraPanel;
